<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="ID" placeholder="Tìm theo ID" :initialValue="sValue_ID"
                                v-model="sValue_ID" :isRequire=false :key="tempKey" @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Tên" placeholder="Tìm theo tên" :initialValue="sValue_TEN"
                                v-model="sValue_TEN" :isRequire=false :key="tempKey" @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <div class="form-group">
                                <label>
                                    <span>Hiển thị trên cổng</span>
                                </label>
                                <select id="enabled_sOptions" class="form-control select2bs4" style="width: 100%">
                                    <option :value=null>--- Tất cả ---</option>
                                    <option :value=true>Bật</option>
                                    <option :value=false>Tắt</option>
                                </select>
                            </div>
                        </div>
                        <div class="col mb-3">
                            <label>
                                Tỉnh
                            </label>
                            <select id="tinhTp_sOptions" class="form-control select2bs4" style="width: 100%">
                                <option value="">Tỉnh Đồng Tháp</option>
                                <!-- <option v-for="item in category_TINHTP" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </option> -->
                            </select>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col10 cursor" @click="handleSortChange('quanHuyenId')">
                                        ID quận huyện
                                        <span v-if="(orderDesc == false && sortBy == 'quanHuyenId')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'quanHuyenId')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('ten')">
                                        Tên quận huyện
                                        <span v-if="(orderDesc == false && sortBy == 'ten')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'ten')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenTinhTp')">
                                        Tên thành phố
                                        <span v-if="(orderDesc == false && sortBy == 'tenTinhTp')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'tenTinhTp')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col10 cursor" @click="handleSortChange('stt')">
                                        STT
                                        <span v-if="(orderDesc == false && sortBy == 'stt')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'stt')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Hiển thị trên cổng</th>
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td></td>
                                    <td>{{ item.quanHuyenId }}</td>
                                    <td>{{ item.ten }}</td>
                                    <td>{{ item.tenTinhTp }}</td>
                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :id="'item' + item.appId" v-model="item.enabledDisplay" disabled="true">
                                            <label class="custom-control-label" :for="'item' + item.appId"></label>
                                        </div>
                                    </td>
                                    <td>
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, 'detail')" title="Xem chi tiết">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">Chi tiết</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="modelRec">
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">

                                    <p class="text-sm">Quận/huyện ID:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.quanHuyenId }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Tên quận/huyện
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ten }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Tên tỉnh/thành phố
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenTinhTp }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">STT
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">Hiển thị trên cổng:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                                            }}&nbsp;</b>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';

import { quanHuyenModel } from '@/models/danhmuc/quanHuyen.model'

export default {
    name: "TheDMQuanHuyen",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,

            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadonly: null,


            sValue_ID: null,
            sValue_TEN: null,
            sValue_TINHTP: null,
            sValue_SORT: null,
            sValue_ENABLED: null,

            category_TINHTP: [],

            sType_List: 1,

            tempKey: common.randomString(10)
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('quanHuyenDM', ['getPagingQuanHuyenDM', 'getDetailQuanHuyenDM']),
        ...mapActions('tinhTPDM', ['getBasicTinhTPDM']),
        async setup() {
            let header = 'Danh sách quận huyện'
            this.setupHeader({ header })
        },

        async initialize() {


            $('#enabled_sOptions').on('change', e => {
                let a = e.target.value
                let returnValue = null
                switch (a) {
                    case "true":
                        returnValue = true
                        break
                    case "false":
                        returnValue = false
                        break
                    default:
                        returnValue = null
                }
                this.sValue_ENABLED = returnValue
                this.handlePageChange(1)
            });
        },

        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },

        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.sValue_SORT = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == 2) this.sType_List = 1
            else if (this.sType_List == 1) this.sType_List = 2
            await this.handlePageChange(1)
        },

        async getData() {
            this.isBusy = true
            let params = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                quanHuyenId: this.sValue_ID == "" ? null : this.sValue_ID,
                //tinhTpId: this.sValue_TINHTP,
                ten: this.sValue_TEN == "" ? null : this.sValue_TEN,
                sort: this.sValue_SORT,
                enabled: this.sValue_ENABLED,
            }
            await this.getPagingQuanHuyenDM({ params: params, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].enabledDisplay = this.items[i].enabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('labels.styleButton' + code)
            this.styleTitle = this.$t('labels.styleTitle' + code)
            this.errors = quanHuyenModel.errors()

            if (this.code == 'detail') {
                let params = {
                    quanHuyenId: item.quanHuyenId
                }
                await this.getDetailQuanHuyenDM({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = quanHuyenModel.newModel()
                        this.modelRec = resp
                    }
                });
                this.tempKey = common.randomString(10)
                this.showPopupDetail()
            }
        },

        async getCategory_TINHTP() {
            let params = {

            }
            let res = await this.getBasicTinhTPDM({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].tinhTpId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },


    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()

        //this.category_TINHTP = await this.getCategory_TINHTP()
    }


}
</script>
<style></style>